import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import AdminLayout from '../Componets/AdminLayout'; // Ensure the path is correct
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import { TbTrophyOff, TbTrophy } from 'react-icons/tb';

export default function ListMarks() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const { subjectId, examId, subjectName, ExamName } = location.state || {};
  const navigate = useNavigate();
  const [records, setRecords] = useState([]); // State for storing fetched faculty records
  const [currentPage, setCurrentPage] = useState(1); // Current page number
  const [perPage, setPerPage] = useState(10); // Number of items per page
  const [searchTerm, setSearchTerm] = useState(''); // State for search term
  const [marksData, setMarksData] = useState({}); // Store marks for each row
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('Click To Upload File For Marks');
  const [prevMarksData, setPrevMarksData] = useState({});

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    if (examId && subjectId) {
      fetchRecords();
    }
  }, [examId, subjectId, apiUrl, navigate]);
  const fetchRecords = async () => {
    const token = localStorage.getItem('token'); // Retrieve token from localStorage
    if (!token) {
      navigate('/');
      return;
    }
    try {
      const response = await axios.get(
        `${apiUrl}/api/final-marks/student-list/${examId}/${subjectId}?resultType=NORMAL`,
        {
          headers: {
            Authorization: token, // Set Authorization header with token
          },
        }
      );
      setRecords(response.data);
    } catch (error) {
      console.error('Error fetching records:', error);
      if (error.response?.status === 401) {
        navigate('/');
      }
    }
  };
  const handleMarksChange = (row, value) => {
    setMarksData((prev) => ({
      ...prev,
      [row.barcodes]: value, // Use barcode as a unique key
    }));
  };

  const handleMarksBlur = async (row) => {
    const marks = marksData[row.barcodes]?.trim(); // Get the updated marks value

    // Do not call API if marks are not changed
    if (marks === prevMarksData[row.barcodes]) return;

    if (!marks) return; // Prevent empty submissions

    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('Unauthorized access!');
      navigate('/');
      return;
    }

    const data = {
      examId: +row.examId,
      subjectId: +row.subjectId,
      barcode: row.barcodes,
      marks: +marks, // Convert to integer
      isManualMark: row.isManualMark,
    };

    try {
      const response = await axios.post(
        `${apiUrl}/api/final-marks/add?resultType=NORMAL`,
        data,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      toast.success(response.data.message);
      setPrevMarksData((prev) => ({ ...prev, [row.barcodes]: marks })); // Update previous marks state
      fetchRecords(); // Refresh the table after update
    } catch (error) {
      console.error('Error updating marks:', error);
      setMarksData((prev) => ({ ...prev, [row.barcodes]: null }));
      toast.error(error.response?.data?.message);
    }
  };

  const handleDeleteMarks = async (row) => {
    if (!window.confirm('Are you sure you want to delete this mark?')) return;

    try {
      const response = await axios.delete(
        `${apiUrl}/api/final-marks/${row.resultId}/${examId}/${row.barcodes}`,
        {
          headers: {
            Authorization: localStorage.getItem('token'), // Replace with actual token
          },
        }
      );

      toast.success(response.data.message);
      fetchRecords();
      setMarksData((prev) => ({ ...prev, [row.barcodes]: null }));
    } catch (error) {
      console.error('Error deleting marks:', error);
      toast.error('Failed to delete marks.');
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault(); // Prevent default tab behavior
      const inputs = document.querySelectorAll('input'); // Get all input fields
      const currentIndex = [...inputs].indexOf(e.target);

      if (e.shiftKey) {
        // Shift + Tab: Move focus to the previous input
        if (currentIndex > 0) {
          inputs[currentIndex - 1].focus();
        }
      } else {
        // Tab: Move focus to the next input
        if (currentIndex < inputs.length - 1) {
          inputs[currentIndex + 1].focus();
        }
      }
    }
  };

  const columns = [
    {
      name: 'No',
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,
      width: '50px',
      center: 'true',
    },
    {
      name: 'Status',
      selector: (row) => {
        if (!row.externalStatus) {
          return ''; // No status displayed if externalStatus is not available
        }

        return row.externalStatus === 'Pass' ? (
          <span style={{ color: 'green', fontWeight: 'bold' }}>PASS</span>
        ) : (
          <span style={{ color: 'red', fontWeight: 'bold' }}>FAIL</span>
        );
      },
      width: '100px',
      center: 'true',
    },

    {
      name: 'Roll No',
      selector: (row) => row.rollNumber,
      sortable: true,
      width: '100px',
      center: 'true',
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },

    {
      name: 'Total Theory Marks',
      selector: (row) => row.externalTotalMarks,
      sortable: true,
      width: '170px',
      center: 'true',
    },
    {
      name: 'Passing Marks',
      selector: (row) => row.externalPassingMarks,
      sortable: true,
      width: '140px',
      center: 'true',
    },
    {
      name: 'Manual Marks',
      width: '120px',
      cell: (row, rowIndex, column, id) => (
        <input
          type="text"
          value={marksData[row.barcodes] ?? row.subjectExistMark ?? ''}
          className="form-control form-control-sm"
          placeholder="Enter Marks"
          onChange={(e) => handleMarksChange(row, e.target.value)}
          onBlur={() => handleMarksBlur(row)}
          onKeyDown={(e) => handleKeyDown(e, rowIndex)}
          data-row-index={rowIndex} // Store row index for reference
        />
      ),
    },
    {
      name: 'Actions',
      width: '115px',
      center: 'true',
      cell: (row) => (
        <button
          className="btn btn-outline-danger btn-sm"
          disabled={row.subjectExistMark === null}
          onClick={() => handleDeleteMarks(row)}
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Delete Student Marks"
        >
          <i className="bi bi-trash3-fill"></i>
        </button>
      ),
    },
  ];
  const exportToExcel = (isManual) => {
    if (records.length === 0) {
      toast.error('No data available to export.');
      return;
    }
    // Filter records based on the isManual flag
    const filteredRecords = isManual
      ? records.filter((row) => row.isManualMark === true)
      : records.filter((row) => row.isManualMark === false);
    if (filteredRecords.length === 0) {
      toast.error(
        `No ${isManual ? 'manual' : 'non-manual'} marks data available to export.`
      );
      return;
    }
    const data = filteredRecords.map((row) => ({
      'Roll No': row.rollNumber,
      Name: row.name,
      Barcode: row.barcodes,
      Marks: marksData[row.barcodes] ?? row.subjectExistMark ?? '',
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    // Set column width
    ws['!cols'] = [
      { wpx: 50 }, // Roll No
      { wpx: 200 }, // Name
      { wpx: 80 }, // Barcode
      { wpx: 40 }, // Marks
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Marks List');
    XLSX.writeFile(wb, `Marks_List_${subjectName}.xlsx`);
  };
  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setFile(event.target.files[0]);
      setFileName(event.target.files[0].name);
    } else {
      setFileName('Click To Upload File For Marks');
    }

    // Reset input value to allow selecting the same file again
    event.target.value = '';
  };

  const handleUpload = async () => {
    if (!file) {
      toast.error('Please select a file before uploading.');
      return;
    }

    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('examId', +examId);
    formData.append('subjectId', +subjectId);
    formData.append('TotalMarks', file);
    formData.append('resultType', 'NORMAL');

    try {
      const response = await axios.post(
        `${apiUrl}/api/final-marks/upload`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      toast.success(response.data.message);
      fetchRecords();
      setFile(null);
      setFileName('Click To Upload File For Marks');
      closemodel();
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.message);
      setFile(null);
      fetchRecords();
      closemodel();
    }
  };

  const closemodel = () => {
    const closeButton = document.querySelector('#exampleModal .btn-close');
    if (closeButton) {
      closeButton.click();
    }
  };

  return (
    <main id="main" className="main">
      <AdminLayout ac12="active">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="cursor-pointer" onClick={() => navigate(-2)}>
                  Exams for Manual Result
                </span>
              </li>
              <li className="breadcrumb-item">
                <span className="cursor-pointer" onClick={() => navigate(-1)}>
                  Subject list
                </span>
              </li>
              <li className="breadcrumb-item active">
                Menual Marks list ({subjectName})
              </li>
            </ol>
          </nav>
        </div>
        <hr className="mb-0" />

        <div className="row">
          <div className="container">
            <div className="datatable-top">
              <div className="datatable-search">
                <input
                  className="form-control"
                  type="search"
                  placeholder="Search"
                  title="Search within table"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-primary mx-2"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content="Upload Marks"
                >
                  <i className="bi bi-upload"></i>
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content=" Reassessment Marks Add Manually"
                  onClick={() =>
                    navigate('/reassmarks', {
                      state: { subjectId, examId, subjectName, ExamName },
                    })
                  }
                >
                  <i className="bi bi-bootstrap-reboot"></i>
                </button>
              </div>
            </div>

            <div className="table-responsive">
              <DataTable
                columns={columns}
                data={records.filter((record) =>
                  record.name.toLowerCase().includes(searchTerm.toLowerCase())
                )}
                pagination
                paginationTotalRows={records.length}
                paginationRowsPerPageOptions={
                  records.length > 40
                    ? [10, 15, 20, 40, records.length]
                    : [10, 15, 20, 40]
                }
                onChangePage={setCurrentPage}
                className="custom-table"
              />
              <ToastContainer position="top-center" style={{ width: 'auto' }} />
            </div>
          </div>
        </div>

        <Tooltip id="my-tooltip" />
      </AdminLayout>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Modal title
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="col text-center">
                <label className="mb-2">Upload Student Details </label>
                <div
                  className="upload-area"
                  onClick={() =>
                    document.getElementById('formFile-question').click()
                  }
                  style={{ cursor: 'pointer', width: '465px' }}
                >
                  <div className="icon">
                    <img
                      src="https://cdn-icons-png.freepik.com/512/16001/16001736.png"
                      alt="Upload"
                    />
                  </div>
                  <p className="text">{fileName}</p>
                  <input
                    className="form-control"
                    name="questionpaper"
                    type="file"
                    id="formFile-question"
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    accept=".xlsx"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-success  mx-1"
                onClick={() => exportToExcel(true)}
              >
                <TbTrophy className="fs-5" />
              </button>
              <button
                className="btn btn-primary"
                onClick={() => exportToExcel(false)}
              >
                <TbTrophyOff className="fs-5" />
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUpload}
              >
                Uplode
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
